
import {
  Obra
} from '../index';


export class ObraDetalhePOMIGOItem {
  "ObraId";
  "item";
  "mIGO";
  "descricao";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraDetalhePOMIGOItem`.
   */
  static getModelName() {
    return "ObraDetalhePOMIGOItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraDetalhePOMIGOItem for dynamic purposes.
  **/
  static factory(data) {
    return new ObraDetalhePOMIGOItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraDetalhePOMIGOItem',
      plural: 'ObraDetalhePOMIGOItems',
      path: 'ObraDetalhePOMIGOItems',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "item": {
          name: 'item',
          type: 'string'
        },
        "mIGO": {
          name: 'mIGO',
          type: 'string'
        },
        "descricao": {
          name: 'descricao',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraDetalhePOMIGOItem.js